export default __webpack_public_path__ + "static/media/ResultOk.6f241474.png";